import _extends from '@babel/runtime/helpers/esm/extends';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { niTrackEvent } from '@xsite-ui/common.event-tracker';
import { ProgressBar } from '@xsite-ui/prequal-funnels.progress-bar';
import { SingleProductPageResult } from '@xsite-ui/prequal-funnels.single-product-page';
import debounce from 'lodash.debounce';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Questionnaire } from 'xsite-ni-questionnaire';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { PROFILE_FIELDS_KEYS, CONSENT_PROFILE_FIELDS, FadeInBackwards, minDesktopWidth, mainGreen, dropdownHover, getPixelLabelJSON, INPUT_TYPES } from '@xsite-ui/prequal-funnels.constants';
import NextArrow from '@xsite-ui/prequal-funnels.assets/next-arrow';
import { PrequalInputFactory } from '@xsite-ui/prequal-funnels.input-factory';
import { Tooltip } from '@xsite-ui/prequal-funnels.tooltip';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var prepareValuesForQuestionnairePackage = function prepareValuesForQuestionnairePackage(stepInputState) {
  var _ageAnswer;

  var ageAnswer;
  var res = stepInputState.map(function (questionInputState) {
    var value = questionInputState.value,
        questionId = questionInputState.questionId,
        answerId = questionInputState.answerId,
        key = questionInputState.key;

    if (key === 'date_of_birth') {
      var age = getAge(value);
      ageAnswer = {
        questionIdentifier: '6460f28dfc7d124618a47a2f',
        answerIdentifier: '6460f28cfc7d124618a479e9',
        answerValue: age
      };
    }

    return {
      questionIdentifier: questionId,
      answerIdentifier: answerId,
      answerValue: value
    };
  });

  if (((_ageAnswer = ageAnswer) === null || _ageAnswer === void 0 ? void 0 : _ageAnswer.answerValue) > 0) {
    res.push(ageAnswer);
  }

  return res.filter(function (answer) {
    var _answer$answerValue;

    return (answer === null || answer === void 0 ? void 0 : answer.answerValue) || (answer === null || answer === void 0 ? void 0 : (_answer$answerValue = answer.answerValue) === null || _answer$answerValue === void 0 ? void 0 : _answer$answerValue.toString());
  });
};
var getReplacedTextPlaceholders = function getReplacedTextPlaceholders(text, questionnaireLocalInputState) {
  if (!text) {
    return text;
  }

  var regexp = /{.*?}/g;
  var placeholders = text.match(regexp);

  if (!placeholders) {
    return text;
  }

  var mapOfQuestionnaireValues = {};

  var _iterator = _createForOfIteratorHelper(questionnaireLocalInputState.flat()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var input = _step.value;

      if (input) {
        mapOfQuestionnaireValues[input.key] = input.displayValue || input.value || '';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var replacedText = placeholders.map(function (placeholder) {
    var textToDisplay = mapOfQuestionnaireValues[placeholder.slice(1, -1)];
    return placeholder.replace(regexp, textToDisplay);
  });
  var idx = 0;
  return text.replace(regexp, function () {
    return replacedText[idx++];
  });
};
var createLeadPayload = function createLeadPayload() {
  var _document, _document$querySelect, _document2, _document2$querySelec, _document3, _document3$querySelec;

  var customParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var payload = customParams;
  var jornayaUid = (_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect = _document.querySelector('#leadid_token')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
  var trustedFormToken = ((_document2 = document) === null || _document2 === void 0 ? void 0 : (_document2$querySelec = _document2.querySelector("input[name='xxTrustedFormCertUrl']")) === null || _document2$querySelec === void 0 ? void 0 : _document2$querySelec.value) || ((_document3 = document) === null || _document3 === void 0 ? void 0 : (_document3$querySelec = _document3.querySelector('#xxTrustedFormCertUrl_0')) === null || _document3$querySelec === void 0 ? void 0 : _document3$querySelec.value);

  if (jornayaUid) {
    payload.jornayaUid = jornayaUid;
  }

  if (trustedFormToken) {
    payload.trustedFormToken = trustedFormToken;
  }

  return payload;
};

var getXSRFToken = function getXSRFToken() {
  var cookies = document.cookie.split(';');

  var _iterator2 = _createForOfIteratorHelper(cookies),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var cookie = _step2.value;

      if (cookie.includes('XSRF-TOKEN')) {
        return cookie.split('=')[1];
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return '';
};

var getAge = function getAge(dob) {
  if (dob) {
    var birthDate = new Date(dob);
    var birthYear = birthDate.getFullYear();
    var now = new Date().getFullYear();
    return now - birthYear;
  }

  return -1;
};

var sendLeadsToPartnerAsync = function sendLeadsToPartnerAsync() {
  var leadPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var productIdsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var leadRequests = productIdsList.map(function (productId) {
    var _window, _window$location;

    var bodyPayload = {
      data: {
        'fs-lead': {
          endpoint: '/api/v1/lead',
          payload: {
            productId: productId,
            lead: leadPayload
          }
        }
      }
    };
    return fetch(((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) || "/", {
      headers: {
        'Content-Type': 'application/json',
        'csrf-token': getXSRFToken(),
        Accept: 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(bodyPayload),
      keepalive: true
    })["catch"](function (error) {
      throw new Error("Failed to send lead to ".concat(productId, ".\nPayload: ").concat(JSON.stringify(bodyPayload), "\nResponse: ").concat(error));
    }).then(function (response) {
      return response.json();
    });
  });
  return Promise.all(leadRequests);
};
var sendLeadToCake = function sendLeadToCake() {
  var _window2, _window2$location;

  var leadPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var productId = arguments.length > 1 ? arguments[1] : undefined;
  var bodyPayload = {
    data: {
      'fs-lead': {
        endpoint: '/api/v1/cake',
        payload: {
          productId: productId,
          lead: leadPayload
        }
      }
    }
  };
  fetch(((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.href) || "/", {
    headers: {
      'Content-Type': 'application/json',
      'csrf-token': getXSRFToken(),
      Accept: 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(bodyPayload),
    keepalive: true
  })["catch"](function (error) {
    throw new Error("Failed to send lead to ".concat(productId, ".\nPayload: ").concat(JSON.stringify(bodyPayload), "\nResponse: ").concat(error));
  });
};
var sendLeadToCakeAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _window3, _window3$location;

    var leadPayload,
        productId,
        bodyPayload,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            leadPayload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            productId = _args.length > 1 ? _args[1] : undefined;
            bodyPayload = {
              data: {
                'fs-lead': {
                  endpoint: '/api/v1/cake',
                  payload: {
                    productId: productId,
                    lead: leadPayload
                  }
                }
              }
            };
            _context.next = 5;
            return fetch(((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.href) || "/", {
              headers: {
                'Content-Type': 'application/json',
                'csrf-token': getXSRFToken(),
                Accept: 'application/json'
              },
              method: 'POST',
              body: JSON.stringify(bodyPayload),
              keepalive: true
            })["catch"](function (error) {
              throw new Error("Failed to send lead to ".concat(productId, ".\nPayload: ").concat(JSON.stringify(bodyPayload), "\nResponse: ").concat(error));
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendLeadToCakeAsync() {
    return _ref.apply(this, arguments);
  };
}();
var createRedirectURL = function createRedirectURL(currentUrl, redirectUrl) {
  var newRedirectUrl = redirectUrl;

  if (currentUrl.host.includes('m.')) {
    newRedirectUrl.href.replace('www.', 'm.');
  } else if (currentUrl.host.includes('pl.')) {
    newRedirectUrl.href.replace('www.', 'pl.');
  }

  var _iterator3 = _createForOfIteratorHelper(currentUrl.searchParams),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
          key = _step3$value[0],
          value = _step3$value[1];

      newRedirectUrl.searchParams.append(key, value);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return newRedirectUrl;
};
var getNewStepInputValues = function getNewStepInputValues(currentStep, currentStepInputValues, profileKey, newInputValue, displayValue, isNewInputValid, questionId, answerId, questionIndex) {
  switch (profileKey) {
    // for special cases that require entire step management (Address, vehicles, more?)
    case 'fullAddress':
      {
        var fullAddressComponent = newInputValue;
        var newStepInputValues = currentStep.questions.map(function (q) {
          var _q$config;

          var profileField = ((_q$config = q.config) === null || _q$config === void 0 ? void 0 : _q$config.profileKey) || '';
          var profileValue = fullAddressComponent[profileField] || '';
          return {
            key: profileField,
            value: profileValue,
            displayValue: displayValue,
            isValid: isNewInputValid,
            questionId: q.id,
            answerId: q.answers[0].id
          };
        });
        return newStepInputValues;
      }

    case 'privacy_terms_approved':
      {
        var consentComponent = newInputValue;

        var _newStepInputValues = currentStep.questions.map(function (q) {
          var _q$config2;

          var profileField = (q === null || q === void 0 ? void 0 : (_q$config2 = q.config) === null || _q$config2 === void 0 ? void 0 : _q$config2.profileKey) || '';
          var profileValue = consentComponent[profileField] || '';
          return {
            key: profileField,
            value: profileValue,
            displayValue: displayValue,
            isValid: CONSENT_PROFILE_FIELDS.includes(profileField),
            questionId: q.id,
            answerId: q.answers[0].id
          };
        });

        return _newStepInputValues;
      }

    default:
      {
        var newCurrentStepInputValues = _toConsumableArray(currentStepInputValues);

        var newInputObject = {
          key: profileKey,
          value: newInputValue,
          displayValue: displayValue,
          isValid: isNewInputValid,
          questionId: questionId,
          answerId: answerId
        };
        newCurrentStepInputValues[questionIndex] = newInputObject; // if the question contains consent, include all the fields that exist
        // this prevents overwrites during unorganized async calls between steps

        var consentFields = [];

        if (!newCurrentStepInputValues.some(function (stepInputsValue) {
          return (stepInputsValue === null || stepInputsValue === void 0 ? void 0 : stepInputsValue.key) === PROFILE_FIELDS_KEYS.privacy_terms_approved;
        }) && currentStep.questions.some(function (q) {
          return q.config.profileKey === PROFILE_FIELDS_KEYS.privacy_terms_approved;
        })) {
          var _consentComponent = {
            privacy_terms_approved: true,
            tcpa: true,
            tcpa_optinDate: new Date()
          };

          var _iterator4 = _createForOfIteratorHelper(currentStep.questions),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _q$config3;

              var q = _step4.value;
              var profileField = (q === null || q === void 0 ? void 0 : (_q$config3 = q.config) === null || _q$config3 === void 0 ? void 0 : _q$config3.profileKey) || '';

              if (CONSENT_PROFILE_FIELDS.includes(profileField)) {
                var profileValue = _consentComponent[profileField] || '';
                consentFields.push({
                  key: profileField,
                  value: profileValue,
                  displayValue: displayValue,
                  isValid: true,
                  questionId: q.id,
                  answerId: q.answers[0].id
                });
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }

        return [].concat(_toConsumableArray(newCurrentStepInputValues), consentFields);
      }
  }
};
var FULL_ADDRESS_STEP_QUESTIONS_AMOUNT = 6;
var shouldNotRenderQuestion = function shouldNotRenderQuestion(currentStep, currentQuestion, questionIndex) {
  var config = currentQuestion.config;

  if (currentStep.questions[0].config.profileKey === 'fullAddress' && currentStep.questions.length === FULL_ADDRESS_STEP_QUESTIONS_AMOUNT && questionIndex > 0) {
    return true;
  }

  if (config.profileKey === PROFILE_FIELDS_KEYS.tcpa || config.profileKey === PROFILE_FIELDS_KEYS.tcpa_optinDate) {
    return true;
  }

  return false;
};
var extractTextFromHTML = function extractTextFromHTML(html) {
  var temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent;
};
var extractAttributesFromStep = function extractAttributesFromStep(step) {
  var stepAttributes = {};

  var _iterator5 = _createForOfIteratorHelper(step.attributes),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var att = _step5.value;
      stepAttributes[att.name] = att.value.text;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return stepAttributes;
};
var sendManualProfileKey = function sendManualProfileKey(profileKey, value) {
  return fetch("/api/v1/user/profile", {
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
    method: 'POST',
    body: JSON.stringify([{
      key: profileKey,
      value: value,
      source: 'questionnaire'
    }])
  }).then(function (res) {
    return res.json();
  })["catch"](function (error) {
    return "failed to send profileKey- ".concat(profileKey, " with the value - ").concat(value, ". the err is - ").concat(error);
  });
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var FormWrapper = styled.form(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 16px 40px;\n  width: 100%;\n  min-height: 516px;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  margin: 0 auto;\n  text-align: center;\n  animation: ", " 0.4s both;\n\n  @media (min-width: ", ") {\n    min-height: 524px;\n  }\n\n  ", "\n"])), FadeInBackwards, minDesktopWidth, function (props) {
  return (props === null || props === void 0 ? void 0 : props.isResultPage) && "padding: unset; padding-bottom: 40px;";
});
var Title = styled.h1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-width: 500px;\n  padding-top: 16px;\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.55px;\n  animation: ", " 0.4s both;\n\n  ", "\n\n  @media (min-width: ", ") {\n    font-size: 32px;\n  }\n"])), FadeInBackwards, function (props) {
  return props !== null && props !== void 0 && props.isLandingPage ? "\n      max-width: 492px;\n      padding-top: 56px;\n      &, * {\n        font-size: 36px;\n        letter-spacing: -0.45px;\n        font-weight: 700;\n        line-height: 130%;\n\n        @media (min-width: ".concat(minDesktopWidth, ") {\n          font-size: 38px;\n          letter-spacing: 0.43px;\n        }   \n      }\n    ") : '';
}, minDesktopWidth);
var Subtitle = styled.h2(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-top: 8px;\n  font-size: 16px;\n  animation: ", " 0.5s both;\n\n  ", "\n"])), FadeInBackwards, function (props) {
  return props !== null && props !== void 0 && props.isLandingPage ? "\n      padding-top: 14px;\n      &, * {\n        font-weight: 600;\n        font-size: 18px;\n        line-height: 28px;\n        letter-spacing: 0.43px;\n      }\n      " : '';
});
var QuestionsWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 344px;\n  padding-top: 34px;\n  display: flex;\n  flex-flow: column nowrap;\n  z-index: 2;\n  > * {\n    animation: ", " 0.7s both;\n  }\n"])), FadeInBackwards);
var QuestionContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  z-index: 2;\n  ", "\n\n  &:not(:nth-of-type(1)) {\n    padding-top: 18px;\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.isConsent ? "\n        order: 10;" : "";
});
var QuestionTitle = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 600;\n  animation: ", " 0.4s both;\n"])), FadeInBackwards);
var SubmitButton = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  max-width: 345px;\n  width: 100%;\n  border: none;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 16px;\n  margin: 30px 0 48px 0;\n  border-radius: 28px;\n  z-index: 1;\n  transition: background-color 0.2s;\n  box-shadow: 0 7px 16px rgb(0 0 0 / 10%);\n  animation: ", " 0.8s both;\n\n  ", "\n"])), mainGreen, FadeInBackwards, function (props) {
  return props !== null && props !== void 0 && props.disabled ? "\n      ".concat(props.isLandingPage ? "" : "background-color: ".concat(dropdownHover), "\n    ") : "  \n      cursor: pointer;\n      &:active,\n      &:hover {\n      background-color: #59aa7b;\n      }\n    ";
});
var BelowCtaContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  animation: ", " 0.9s both;\n  & > div {\n    display: flex;\n    font-size: 13px;\n    div {\n      display: flex;\n      align-items: center;\n      p {\n        padding: 0 10px 0 4px;\n        white-space: nowrap;\n      }\n      :last-of-type p {\n        padding-right: 0;\n      }\n    }\n  }\n\n  @media (min-width: ", ") {\n    & > div {\n      font-size: 14px;\n      p {\n        white-space: nowrap;\n        padding: 0 20px 0 4px;\n      }\n      img {\n        height: 26px;\n      }\n    }\n  }\n\n  @media (max-width: 374px) {\n    display: none;\n  }\n"])), FadeInBackwards, minDesktopWidth);

var shouldShowSubmitButton = function shouldShowSubmitButton(questionType) {
  return ![INPUT_TYPES['single_choice']].includes(questionType);
};

var PrequalFunnel = function PrequalFunnel(_ref) {
  var _currentStep$question, _currentStep$question3, _currentStep$question4, _currentStepInputValu;

  var questionnaireStep = _ref.questionnaireStep,
      initNextStep = _ref.initNextStep,
      cdnContextProps = _ref.cdnContextProps;
  var currentStep = questionnaireStep.currentStep,
      currentStepNumber = questionnaireStep.currentStepNumber,
      userClickedBack = questionnaireStep.userClickedBack;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      questionnaireInputState = _useState2[0],
      setQuestionnaireInputState = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      currentStepInputValues = _useState4[0],
      setCurrentStepInputValues = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isCurrentStepValid = _useState6[0],
      setIsCurrentStepValid = _useState6[1];

  var _useState7 = useState(shouldShowSubmitButton(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$question = currentStep.questions[0]) === null || _currentStep$question === void 0 ? void 0 : _currentStep$question.type)),
      _useState8 = _slicedToArray(_useState7, 2),
      showSubmitButton = _useState8[0],
      setShowSubmitButton = _useState8[1];

  var _useState9 = useState(userClickedBack),
      _useState10 = _slicedToArray(_useState9, 2),
      isAPreviousStep = _useState10[0],
      setIsAPreviousStep = _useState10[1];

  useEffect(function () {
    var _currentStep$question2;

    setIsCurrentStepValid(false);
    setIsAPreviousStep(userClickedBack);
    var showSubmit = shouldShowSubmitButton((_currentStep$question2 = currentStep.questions[0]) === null || _currentStep$question2 === void 0 ? void 0 : _currentStep$question2.type);
    setCurrentStepInputValues(function (oldStepInputValues) {
      if (oldStepInputValues) {
        return showSubmit ? questionnaireInputState[currentStepNumber] || oldStepInputValues : [];
      }

      return showSubmit ? questionnaireInputState[currentStepNumber] || [] : [];
    });
    setShowSubmitButton(showSubmit);
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 0);
  }, [questionnaireStep]);
  useEffect(function () {
    if (!showSubmitButton) {
      if (!isAPreviousStep) {
        checkStepValidity();
      }
    } else {
      checkStepValidity();
    }
  }, [currentStepInputValues]);
  useEffect(function () {
    if (isCurrentStepValid && !showSubmitButton) {
      handleStepSubmit();
    }
  }, [isCurrentStepValid]);

  var handleStepSubmit = function handleStepSubmit() {
    if (!isCurrentStepValid) {
      return;
    }

    setQuestionnaireInputState(function (oldQuestionnaireInputState) {
      var newQuestionnaireInputValues = _toConsumableArray(oldQuestionnaireInputState);

      newQuestionnaireInputValues[currentStepNumber] = currentStepInputValues;
      return newQuestionnaireInputValues;
    });
    initNextStep(currentStepInputValues);
    setCurrentStepInputValues([]);
  };

  var checkStepValidity = function checkStepValidity() {
    if (!currentStepInputValues || currentStepInputValues.length === 0 || currentStepInputValues.length !== currentStep.questions.length) {
      setIsCurrentStepValid(false);
    } else {
      var isStepValid = true;

      var _iterator = _createForOfIteratorHelper(currentStepInputValues),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var question = _step.value;

          if (!question || !question.isValid) {
            isStepValid = false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      setIsCurrentStepValid(isStepValid);
    }
  };

  var _handleQuestionInputChange = function handleQuestionInputChange(profileKey, newInputValue, displayValue, isNewInputValid, questionId, answerId, questionIndex) {
    setIsAPreviousStep(false);
    var newStepInputValues = getNewStepInputValues(currentStep, currentStepInputValues, profileKey, newInputValue, displayValue, isNewInputValid, questionId, answerId, questionIndex);
    setCurrentStepInputValues(newStepInputValues);
  };

  var stepAttributes = extractAttributesFromStep(currentStep);
  var title = stepAttributes.title,
      subTitle = stepAttributes.subTitle,
      ctaText = stepAttributes.ctaText,
      belowCtaContent = stepAttributes.belowCtaContent,
      tooltipTitle = stepAttributes.tooltipTitle,
      tooltipText = stepAttributes.tooltipText,
      tooltipShowByDefault = stepAttributes.tooltipShowByDefault,
      showSubmitButtonArrow = stepAttributes.showSubmitButtonArrow,
      richTitle = stepAttributes.richTitle;
  var titleText = getReplacedTextPlaceholders(title, questionnaireInputState);
  var subtitleText = getReplacedTextPlaceholders(subTitle, questionnaireInputState);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    key: "title".concat(currentStepNumber),
    isLandingPage: currentStepNumber === 0,
    dangerouslySetInnerHTML: {
      __html: titleText
    }
  }), subtitleText && /*#__PURE__*/React.createElement(Subtitle, {
    key: "subtitle".concat(currentStepNumber),
    isLandingPage: currentStepNumber === 0,
    dangerouslySetInnerHTML: {
      __html: subtitleText
    }
  }), /*#__PURE__*/React.createElement(QuestionsWrapper, null, currentStep.questions.map(function (question, questionIndex) {
    var _questionnaireInputSt, _questionnaireInputSt2;

    var data = question.data,
        config = question.config;
    var questionTitleText = data === null || data === void 0 ? void 0 : data.title;
    var isConsent = config.profileKey === 'privacy_terms_approved';

    if (shouldNotRenderQuestion(currentStep, question, questionIndex)) {
      return;
    }

    return /*#__PURE__*/React.createElement(QuestionContainer, {
      key: "st".concat(currentStepNumber, "qt").concat(questionIndex),
      isConsent: isConsent
    }, richTitle && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: richTitle
      }
    }), questionTitleText && /*#__PURE__*/React.createElement(QuestionTitle, null, getReplacedTextPlaceholders(questionTitleText, questionnaireInputState)), /*#__PURE__*/React.createElement(PrequalInputFactory, {
      question: question,
      handleQuestionInputChange: function handleQuestionInputChange(profileKey, newInputValue, displayValue, isNewInputValid, questionId, answerId) {
        return _handleQuestionInputChange(profileKey, newInputValue, displayValue, isNewInputValid, questionId, answerId, questionIndex);
      },
      questionInputValueFromQuestionnaire: ['fullAddress'].includes(config.profileKey || '') ? questionnaireInputState[currentStepNumber] : (_questionnaireInputSt = questionnaireInputState[currentStepNumber]) === null || _questionnaireInputSt === void 0 ? void 0 : (_questionnaireInputSt2 = _questionnaireInputSt[questionIndex]) === null || _questionnaireInputSt2 === void 0 ? void 0 : _questionnaireInputSt2.value,
      stepAttributes: currentStep.attributes,
      cdnContextProps: cdnContextProps
    }));
  }), showSubmitButton && /*#__PURE__*/React.createElement(SubmitButton, {
    key: "submit".concat(currentStepNumber),
    type: "submit",
    onClick: handleStepSubmit,
    disabled: !isCurrentStepValid,
    "data-pixel-label": getPixelLabelJSON((currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$question3 = currentStep.questions[0]) === null || _currentStep$question3 === void 0 ? void 0 : (_currentStep$question4 = _currentStep$question3.config) === null || _currentStep$question4 === void 0 ? void 0 : _currentStep$question4.profileKey) || '', currentStepInputValues === null || currentStepInputValues === void 0 ? void 0 : (_currentStepInputValu = currentStepInputValues[0]) === null || _currentStepInputValu === void 0 ? void 0 : _currentStepInputValu.value)
  }, ctaText || 'Next', showSubmitButtonArrow === 'true' && /*#__PURE__*/React.createElement(NextArrow, null))), /*#__PURE__*/React.createElement(BelowCtaContent, {
    dangerouslySetInnerHTML: {
      __html: belowCtaContent
    }
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle,
    text: tooltipText,
    showByDefault: Boolean(tooltipShowByDefault)
  }));
};

PrequalFunnel.displayName = 'PrequalFunnel';

var FIRST_STEP_INDEX = 1;

var PrequalFunnelLayout = function PrequalFunnelLayout(_ref) {
  var _productResultProps$r, _productResultProps$r2, _productResultProps$r3, _productResultProps$r4, _productResultProps$r5;

  var questionnaireRaw = _ref.questionnaireRaw,
      cdnContextProps = _ref.cdnContextProps,
      isMobile = _ref.isMobile,
      funnelData = _ref.funnelData,
      _ref$userProfile = _ref.userProfile,
      userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile,
      uiFeatures = _ref.uiFeatures;

  var _ref2 = funnelData || {},
      _ref2$funnelName = _ref2.funnelName,
      funnelName = _ref2$funnelName === void 0 ? '' : _ref2$funnelName,
      directPartnersProductIds = _ref2.directPartnersProductIds,
      cakePartnerProductId = _ref2.cakePartnerProductId,
      redirectTimeoutTime = _ref2.redirectTimeoutTime,
      funnelHardFilterRedirectParams = _ref2.funnelHardFilterRedirectParams; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var _useState = useState(new Questionnaire(questionnaireRaw, undefined, {
    sendProfileFieldAutomatically: true,
    sendEventsAutomatically: true,
    startingStep: 0
  })),
      _useState2 = _slicedToArray(_useState, 2),
      questionnairePackage = _useState2[0];
      _useState2[1];

  var _useState3 = useState({
    currentStepNumber: 0,
    currentStep: questionnairePackage.questionnaire.steps[0],
    userClickedBack: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      questionnaireStep = _useState4[0],
      setQuestionnaireStep = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      funnelStartedEventSent = _useState6[0],
      setFunnelStartedEventSent = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      productResultProps = _useState8[0],
      setProductResultProps = _useState8[1];

  var totalProgress = questionnaireStep.currentStepNumber * 100 / questionnairePackage.questionnaire.steps.length;
  var shouldShowProgressBar = questionnaireStep.currentStepNumber !== 0;
  useEffect(function () {
    if (window.location.href.includes('debt-consolidation-loans')) {
      sendManualProfileKey('loan_purpose', 'debt_consolidation');
    } // load scripts in bucket?
    // move google script to tealium?


    if (typeof document !== 'undefined' && !window.google || !window.google.maps) {
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBJiN0CVEEHXmy0zwVjZwAGYNfnHdkj-HQ&libraries=places';
      script.defer = true;
      document.head.append(script);
    }

    var fireImpressionTimeOut;

    var fireImpressionEvent = function fireImpressionEvent() {
      if (window.ni) {
        var _questionnaireStep$cu;

        var stepTitle = extractTextFromHTML(((_questionnaireStep$cu = questionnaireStep.currentStep.attributes.find(function (att) {
          return att.name === 'title';
        })) === null || _questionnaireStep$cu === void 0 ? void 0 : _questionnaireStep$cu.value.text) || '') || '';
        niTrackEvent({
          category: 'pre-qualification',
          action: 'Impression - Prequalification Wizard',
          optLabel: stepTitle,
          optValue: 0,
          optNonInteraction: true
        });
        clearTimeout(fireImpressionTimeOut);
      } else {
        clearTimeout(fireImpressionTimeOut);
        fireImpressionTimeOut = window.setTimeout(fireImpressionEvent, 500);
      }
    };

    fireImpressionTimeOut = window.setTimeout(fireImpressionEvent, 500);
    questionnairePackage.onExternalEvent('nigoogle', function (_ref3) {
      var category = _ref3.category,
          action = _ref3.action,
          label = _ref3.label,
          value = _ref3.value,
          non_interactive = _ref3.non_interactive,
          isPii = _ref3.isPii;
      niTrackEvent({
        category: category,
        action: action,
        optLabel: label,
        optValue: isPii ? 'PII' : value,
        optNonInteraction: non_interactive !== null && non_interactive !== void 0 ? non_interactive : false
      });
    });
    questionnairePackage.on('finish', /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var result, resultPageObject, resultStep, resultType, resultName, _redirectUrl$searchPa, timeoutTime, redirectUrl, redirectUrlSearchParams, isHardFilterRedirect, _redirectUrl$searchPa2, _response$content, _response$content$dat, _response$content$dat2, _response$content$dat3, _response$content$dat4, response, cakeResponse, _redirectUrl$searchPa3, prefix;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = _ref4.rawResult, resultPageObject = _ref4.resultPageObject, resultStep = _ref4.resultStep;
                resultType = result.type, resultName = result.name;
                niTrackEvent({
                  category: 'questionnaire',
                  action: 'Complete funnel',
                  optLabel: 'funnel completion',
                  optValue: resultName || '',
                  optNonInteraction: true
                });
                _context.t0 = resultType;
                _context.next = _context.t0 === 'page' ? 6 : _context.t0 === 'product' ? 34 : 36;
                break;

              case 6:
                timeoutTime = redirectTimeoutTime || 0;
                redirectUrl = createRedirectURL(new URL(window.location.href), resultPageObject);
                redirectUrlSearchParams = (redirectUrl === null || redirectUrl === void 0 ? void 0 : (_redirectUrl$searchPa = redirectUrl.searchParams) === null || _redirectUrl$searchPa === void 0 ? void 0 : _redirectUrl$searchPa.toString()) || '';
                isHardFilterRedirect = (funnelHardFilterRedirectParams === null || funnelHardFilterRedirectParams === void 0 ? void 0 : funnelHardFilterRedirectParams.some(function (str) {
                  return redirectUrlSearchParams.includes(str);
                })) || false;

                if (!redirectUrl.href.endsWith('/result')) {
                  _context.next = 14;
                  break;
                }

                niTrackEvent({
                  category: 'questionnaire',
                  action: 'redirected',
                  optLabel: 'hard filter',
                  optValue: 'renters'
                });
                _context.next = 31;
                break;

              case 14:
                if (!isHardFilterRedirect) {
                  _context.next = 18;
                  break;
                }

                niTrackEvent({
                  category: 'questionnaire',
                  action: 'redirected',
                  optLabel: 'hard filter',
                  optValue: (_redirectUrl$searchPa2 = redirectUrl.searchParams) === null || _redirectUrl$searchPa2 === void 0 ? void 0 : _redirectUrl$searchPa2.toString()
                });
                _context.next = 31;
                break;

              case 18:
                if (!(uiFeatures !== null && uiFeatures !== void 0 && uiFeatures['ni-lendtree-lead-ft'] && window.location.href.includes('ts=mr'))) {
                  _context.next = 30;
                  break;
                }

                if (!resultName.includes('LendingTree')) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return sendLeadsAsync(cakePartnerProductId, {
                  lendingtree: true
                });

              case 22:
                response = _context.sent;
                cakeResponse = response === null || response === void 0 ? void 0 : (_response$content = response.content) === null || _response$content === void 0 ? void 0 : (_response$content$dat = _response$content.data) === null || _response$content$dat === void 0 ? void 0 : (_response$content$dat2 = _response$content$dat.content) === null || _response$content$dat2 === void 0 ? void 0 : (_response$content$dat3 = _response$content$dat2.result) === null || _response$content$dat3 === void 0 ? void 0 : (_response$content$dat4 = _response$content$dat3.response) === null || _response$content$dat4 === void 0 ? void 0 : _response$content$dat4.result;

                if (cakeResponse !== null && cakeResponse !== void 0 && cakeResponse.redirect) {
                  // if lead was sold to lending tree - redirect to thank you page
                  niTrackEvent({
                    category: 'questionnaire',
                    action: 'Complete funnel',
                    optLabel: 'funnel completion',
                    optValue: (_redirectUrl$searchPa3 = redirectUrl.searchParams) === null || _redirectUrl$searchPa3 === void 0 ? void 0 : _redirectUrl$searchPa3.toString()
                  });
                  prefix = isMobile ? 'm.' : 'www.';
                  window.location.replace("".concat(window.location.protocol, "//").concat(prefix, "bestmoney.com/personal-loans-shopping/thank-you"));
                }

                _context.next = 28;
                break;

              case 27:
                if (resultName.includes('NDR')) {
                  sendLeads(directPartnersProductIds, cakePartnerProductId, {
                    ndr: true
                  });
                }

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (window.location.href.includes('/debt-consolidation-loans')) {
                  // used for debt-consolidation-loans funnel that uses the same
                  sendLeads([], '64a685ad423952eeb839d00d');
                } else {
                  // default behavior
                  sendLeads(directPartnersProductIds, cakePartnerProductId);
                }

              case 31:
                // report funnel completed via tealium
                if (redirectUrl.href.includes('/home-insurance')) {
                  document.dispatchEvent(new Event('result_type_homeLead'));
                }

                setTimeout(function () {
                  window.location.replace(redirectUrl);
                }, timeoutTime);
                return _context.abrupt("break", 37);

              case 34:
                setProductResultProps({
                  result: result,
                  step: resultStep
                });
                return _context.abrupt("break", 37);

              case 36:
                return _context.abrupt("break", 37);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
  }, []);
  var changeStep = useCallback(debounce(function (step, index, stepDirection) {
    var textBelowChartEl = document.querySelector('[data-show-text-below-chart=true]');

    if (index >= FIRST_STEP_INDEX) {
      var _textBelowChartEl;

      (_textBelowChartEl = textBelowChartEl) === null || _textBelowChartEl === void 0 ? void 0 : _textBelowChartEl.setAttribute('data-show-text-below-chart', 'false');
    } else {
      if (!textBelowChartEl) {
        var _textBelowChartEl2;

        textBelowChartEl = document.querySelector('[data-show-text-below-chart=false]');
        (_textBelowChartEl2 = textBelowChartEl) === null || _textBelowChartEl2 === void 0 ? void 0 : _textBelowChartEl2.setAttribute('data-show-text-below-chart', 'true');
      }
    }

    setQuestionnaireStep({
      currentStep: step,
      currentStepNumber: index,
      userClickedBack: stepDirection === 'back'
    });
  }, 200), []);

  var sendLeadsAsync = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var cakePartner,
          customParams,
          leadPayload,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cakePartner = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              customParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              leadPayload = createLeadPayload(customParams);
              niTrackEvent({
                category: 'questionnaire',
                action: 'result',
                optLabel: 'funnel result',
                optValue: 'LendingTree'
              });
              _context2.next = 6;
              return sendLeadToCakeAsync(leadPayload, cakePartner);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function sendLeadsAsync() {
      return _ref6.apply(this, arguments);
    };
  }();

  var sendLeads = function sendLeads(directPartners, cakePartner) {
    var customParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var leadPayload = createLeadPayload(customParams);

    if (directPartners) {
      sendLeadsToPartnerAsync(leadPayload, directPartners);
    }

    if (cakePartner) {
      sendLeadToCake(leadPayload, cakePartner);
    }

    if (directPartners || cakePartner) {
      // to be in questionnaire?
      niTrackEvent({
        category: 'questionnaire',
        action: 'lead submitted',
        optLabel: funnelName,
        optValue: 'N/A'
      });
    }
  };

  var isLastQuestion = function isLastQuestion(stepId) {
    return questionnairePackage.onlyQuestions[questionnairePackage.onlyQuestions.length - 1].id === stepId;
  };

  var handleNextStep = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(currentStepInputState) {
      var preparedValues, _iterator, _step, inputValue, questionIdentifier, answerIdentifier, answerValue, nextStep;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              preparedValues = prepareValuesForQuestionnairePackage(currentStepInputState); // we need to await questionnaire fill before moving to the result in order to avoid missing parameters in profile fields
              // should fillArray have an async option?
              // should all profilefields be sent async?

              if (!isLastQuestion(questionnaireStep.currentStep.id)) {
                _context3.next = 28;
                break;
              }

              _iterator = _createForOfIteratorHelper(preparedValues);
              _context3.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context3.next = 18;
                break;
              }

              inputValue = _step.value;
              questionIdentifier = inputValue.questionIdentifier, answerIdentifier = inputValue.answerIdentifier, answerValue = inputValue.answerValue;
              _context3.prev = 8;
              _context3.next = 11;
              return questionnairePackage.fillAsync(questionIdentifier, answerIdentifier, answerValue);

            case 11:
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](8);
              console.error("".concat(questionnaireStep.currentStep.id, " error: ").concat(_context3.t0, ", questionId: ").concat(questionIdentifier, ", answerId: ").concat(answerIdentifier, ", value: ").concat(answerValue));

            case 16:
              _context3.next = 5;
              break;

            case 18:
              _context3.next = 23;
              break;

            case 20:
              _context3.prev = 20;
              _context3.t1 = _context3["catch"](3);

              _iterator.e(_context3.t1);

            case 23:
              _context3.prev = 23;

              _iterator.f();

              return _context3.finish(23);

            case 26:
              _context3.next = 29;
              break;

            case 28:
              questionnairePackage.fillArray(preparedValues);

            case 29:
              nextStep = questionnairePackage.getNextStep();

              if (!(nextStep.type === 'results')) {
                _context3.next = 32;
                break;
              }

              return _context3.abrupt("return");

            case 32:
              if (questionnairePackage.currentStepIndex > 0 && !funnelStartedEventSent) {
                setFunnelStartedEventSent(true); // to be in questionnaire

                niTrackEvent({
                  category: 'Funnel Started',
                  action: 'User Started Funnel',
                  optLabel: 'Funnel Started',
                  optValue: 1
                });
              }

              changeStep(nextStep, questionnairePackage.currentStepIndex, 'next');

            case 34:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 20, 23, 26], [8, 13]]);
    }));

    return function handleNextStep(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handlePreviousStep = function handlePreviousStep() {
    var prevStep = questionnairePackage.goBack();
    changeStep(prevStep.resolvedStep, prevStep.index, 'back');
  };

  var getSingleProductPageResultProps = function getSingleProductPageResultProps() {
    var _productResultProps$s, _attributes$find, _attributes$find2, _attributes$find3, _attributes$find4;

    var result = productResultProps === null || productResultProps === void 0 ? void 0 : productResultProps.result;
    var attributes = productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$s = productResultProps.step) === null || _productResultProps$s === void 0 ? void 0 : _productResultProps$s.attributes;
    var ctaTextValFromAttribute = attributes ? (_attributes$find = attributes.find(function (att) {
      return att.name === 'ctaText';
    })) === null || _attributes$find === void 0 ? void 0 : _attributes$find.value.text : '';
    var resultCtaText = (result === null || result === void 0 ? void 0 : result.ctaText) || '';
    return {
      description: (result === null || result === void 0 ? void 0 : result.description) || '',
      bullets: (result === null || result === void 0 ? void 0 : result.bullets) || [],
      bottomLine: result === null || result === void 0 ? void 0 : result.bottomLine,
      image: result === null || result === void 0 ? void 0 : result.image,
      titleText: attributes ? (_attributes$find2 = attributes.find(function (att) {
        return att.name === 'title';
      })) === null || _attributes$find2 === void 0 ? void 0 : _attributes$find2.value.text : '',
      subTitleText: attributes ? (_attributes$find3 = attributes.find(function (att) {
        return att.name === 'subTitle';
      })) === null || _attributes$find3 === void 0 ? void 0 : _attributes$find3.value.text : '',
      showPhone: attributes ? Boolean((_attributes$find4 = attributes.find(function (att) {
        return att.name === 'displayPhoneCta';
      })) === null || _attributes$find4 === void 0 ? void 0 : _attributes$find4.value.text) : false,
      ctaText: resultCtaText || ctaTextValFromAttribute
    };
  };

  var getSingleProductPageResultPropsMemo = useMemo(function () {
    return getSingleProductPageResultProps();
  }, [productResultProps]);
  return /*#__PURE__*/React.createElement(FormWrapper, {
    isResultPage: Boolean((productResultProps === null || productResultProps === void 0 ? void 0 : productResultProps.result) && (productResultProps === null || productResultProps === void 0 ? void 0 : productResultProps.step)),
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    autoComplete: "on"
  }, productResultProps !== null && productResultProps !== void 0 && productResultProps.result && productResultProps !== null && productResultProps !== void 0 && productResultProps.step ? /*#__PURE__*/React.createElement(SingleProductPageResult, _extends({
    productToReport: productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$r = productResultProps.result) === null || _productResultProps$r === void 0 ? void 0 : _productResultProps$r.product,
    displayName: productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$r2 = productResultProps.result) === null || _productResultProps$r2 === void 0 ? void 0 : _productResultProps$r2.product.displayName,
    legacyId: productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$r3 = productResultProps.result) === null || _productResultProps$r3 === void 0 ? void 0 : _productResultProps$r3.product.legacyId,
    phoneNumberAttribute: productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$r4 = productResultProps.result) === null || _productResultProps$r4 === void 0 ? void 0 : _productResultProps$r4.product.phoneNumberAttribute,
    logoPath: productResultProps === null || productResultProps === void 0 ? void 0 : (_productResultProps$r5 = productResultProps.result) === null || _productResultProps$r5 === void 0 ? void 0 : _productResultProps$r5.product.logoPath
  }, getSingleProductPageResultPropsMemo, {
    cdnContextProps: cdnContextProps,
    userProfile: userProfile
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, shouldShowProgressBar && /*#__PURE__*/React.createElement(ProgressBar, {
    totalProgress: totalProgress,
    initPrevStep: handlePreviousStep,
    funnelName: funnelName
  }), /*#__PURE__*/React.createElement(PrequalFunnel, {
    questionnaireStep: questionnaireStep,
    initNextStep: handleNextStep,
    cdnContextProps: cdnContextProps
  })));
};

PrequalFunnelLayout.displayName = 'PrequalFunnelLayout';

export { PrequalFunnelLayout };
